import { LitElement as g, html as c } from "lit";
import { property as i, state as m, customElement as b } from "lit/decorators.js";
import { StyledElement as v } from "../styledElement.js";
import { formatNumber as f } from "@pentacode/core";
/*! @pentacode/ui v0.1.0 */
const _ = `:host {
    --progress-color: var(--orange);
    --_progress-color: var(--progress-color);

    --progress-color-subceeded: var(--red);
    --progress-color-below: var(--orange);
    --progress-color-above: var(--green);
    --progress-color-exceeded: var(--red);

    --progress-color-fg: var(--_progress-color);
    --progress-color-bg: color-mix(in oklab, var(--_progress-color) 25%, transparent);

    display: block;
    background: #fafafa;
    border-radius: var(--border-radius);
    overflow: hidden;
    position: relative;
    text-align: center;
    font-weight: bold;
    font-size: inherit;
    border: solid 1px var(--shade-1);
}

:host([threshold="subceeded"]) {
    --_progress-color: var(--progress-color-subceeded);
}

:host([threshold="subceeded"]) [part="numbers"] {
    color: var(--progress-color-fg);
}

:host([threshold="below"]) {
    --_progress-color: var(--progress-color-below);
}

:host([threshold="above"]) {
    --_progress-color: var(--progress-color-above);
}

:host([threshold="exceeded"]) {
    --_progress-color: var(--progress-color-exceeded);
}

[part="numbers"] {
    padding: 0.2em;
    box-sizing: border-box;
    font-variant-numeric: tabular-nums;
}

[part="progress"] {
    overflow: hidden;
    position: absolute;
    inset: 0;
}

/** clipping from this side is needed to avoid text rendering appearing glitchy */
[part="numbers"] {
    clip-path: xywh(calc(max(0, var(--_progress-amount, 0)) * 100%) 0 100% 100%);
    white-space: nowrap;
}

[part="progress"] [part="numbers"] {
    width: 100%;
    clip-path: xywh(0 0 calc(max(0, var(--_progress-amount, 0)) * 100%) 100%);

    color: var(--progress-color-fg);
    background: var(--progress-color-bg);
}
`;
var x = Object.defineProperty, y = Object.getOwnPropertyDescriptor, n = (r, e, o, t) => {
  for (var a = t > 1 ? void 0 : t ? y(e, o) : e, l = r.length - 1, p; l >= 0; l--)
    (p = r[l]) && (a = (t ? p(e, o, a) : p(a)) || a);
  return t && a && x(e, o, a), a;
};
const h = 0.05, u = 0.95, w = 0;
function d(r, e, o) {
  return e <= r && r <= o;
}
function P({
  current: r,
  tolerance: e,
  min: o,
  max: t
}) {
  return r < o - e ? "subceeded" : r > t + e ? "exceeded" : d(r, o - e, o + e) ? "below" : d(r, t - e, t + e) ? "above" : "within";
}
function E(r) {
  if (r > 0) {
    if (r < h) return h;
    if (r > u && r < 1) return u;
  }
  return r;
}
let s = class extends v(g) {
  constructor() {
    super(...arguments), this.role = "progressbar", this.value = 0, this.min = 0, this.max = 100, this.format = f, this.thresholdLimitTolerance = w, this._relativeProgress = this.value / this.max, this.styles = _;
  }
  willUpdate() {
    this._relativeProgress = this.value / this.max, this.threshold = P({
      current: this._relativeProgress,
      min: this.min / this.max,
      max: this.max / this.max,
      tolerance: this.thresholdLimitTolerance
    });
  }
  render() {
    const { value: r, max: e, _relativeProgress: o } = this, t = c`<div part="numbers" style="--_progress-amount: ${E(o)}">
            ${this.format(r)} / ${this.format(e)}
        </div>`;
    return c`
            <div part="progress">${t}</div>
            ${t}
        `;
  }
};
n([
  i({ type: String, reflect: !0 })
], s.prototype, "role", 2);
n([
  i({ type: Number, reflect: !0, attribute: "aria-valuenow" })
], s.prototype, "value", 2);
n([
  i({ type: Number, reflect: !0, attribute: "aria-valuemin" })
], s.prototype, "min", 2);
n([
  i({ type: Number, reflect: !0, attribute: "aria-valuemax" })
], s.prototype, "max", 2);
n([
  i({ attribute: !1 })
], s.prototype, "format", 2);
n([
  i({ type: Number })
], s.prototype, "thresholdLimitTolerance", 2);
n([
  i({ reflect: !0, attribute: "threshold" })
], s.prototype, "threshold", 2);
n([
  m()
], s.prototype, "_relativeProgress", 2);
s = n([
  b("ptc-ui-progress")
], s);
const N = s;
export {
  s as Progress,
  N as default,
  E as getDisplayedProgress,
  P as getThresholdPosition
};
//# sourceMappingURL=progress.js.map
